const SidePanel = ({ 
  onNewGame, 
  onResign, 
  onOfferDraw,
  matchesLeft, 
  geminiCommentary,
  gameInProgress,
  aiName = 'MasterGemi',
  aiLogo,
  autoPlayEnabled = false,
  onAutoPlayToggle,
  autoPlayThinking,
  moveCount = 0
}) => {
  return (
    <div className="w-80 bg-surface dark:bg-dark-surface border-l-3 border-border-heavy dark:border-dark-border-heavy h-full p-6 flex flex-col gap-6 overflow-hidden">
      {/* Match Info */}
      <div className="bg-background dark:bg-dark-background border-2 border-border dark:border-dark-border p-5">
        <h3 className="text-text-primary dark:text-dark-text-primary font-bold text-base mb-3">Daily Matches</h3>
        <div className="flex items-center gap-3 mb-3">
          <div className="flex-1 bg-surface-dark dark:bg-dark-surface-dark h-3 border-2 border-border dark:border-dark-border">
            <div 
              className="bg-accent dark:bg-dark-accent h-full transition-all duration-150"
              style={{ width: `${(matchesLeft / 3) * 100}%` }}
            />
          </div>
          <span className="text-text-primary dark:text-dark-text-primary text-sm font-mono font-bold">{matchesLeft}/3</span>
        </div>
        <p className="text-text-secondary dark:text-dark-text-secondary text-xs">
          {matchesLeft > 0 ? 'You have matches remaining today' : 'Come back tomorrow for more matches'}
        </p>
      </div>

      {/* Actions */}
      <div className="space-y-4">
        <button 
          onClick={onNewGame}
          disabled={matchesLeft <= 0 && gameInProgress}
          className="btn btn-primary w-full text-sm disabled:opacity-50 disabled:cursor-not-allowed"
        >
          New Game
        </button>
        
        {gameInProgress && (
          <>
            {/* AutoPilot Toggle */}
            <button 
              onClick={onAutoPlayToggle}
              className={`w-full p-3 border-2 text-sm font-bold transition-all flex items-center justify-center gap-2 ${
                autoPlayEnabled 
                  ? 'bg-green-500 dark:bg-green-600 text-white border-green-600 dark:border-green-500 shadow-brutal' 
                  : 'bg-background dark:bg-dark-background text-text-primary dark:text-dark-text-primary border-border dark:border-dark-border hover:shadow-brutal hover:translate-x-0.5 hover:translate-y-0.5'
              }`}
            >
              <span className="text-lg">{autoPlayEnabled ? '🤖' : '🎮'}</span>
              {autoPlayEnabled ? 'AutoPilot ON' : 'Enable AutoPilot'}
            </button>
            
            <button 
              onClick={onOfferDraw}
              disabled={moveCount < 10}
              className="w-full p-3 border-2 text-sm font-bold transition-all bg-yellow-50 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400 border-yellow-500 dark:border-yellow-600 hover:shadow-brutal hover:translate-x-0.5 hover:translate-y-0.5 disabled:opacity-50 disabled:cursor-not-allowed"
            >
              🤝 Offer Draw
            </button>
            
            <button 
              onClick={onResign}
              className="btn btn-secondary w-full text-sm"
            >
              Resign
            </button>
          </>
        )}
      </div>

      {/* AutoPilot Info */}
      {gameInProgress && autoPlayEnabled && (
        <div className="bg-green-50 dark:bg-green-900/30 border-2 border-green-500 dark:border-green-600 p-4">
          <h3 className="text-green-700 dark:text-green-400 font-bold text-sm mb-2 flex items-center gap-2">
            🤖 AutoPilot Active
          </h3>
          <p className="text-green-600 dark:text-green-300 text-xs">
            {autoPlayThinking || 'AI is playing on your behalf. Sit back and watch!'}
          </p>
        </div>
      )}

      {/* AI Commentary */}
      {gameInProgress && (
        <div className="bg-background dark:bg-dark-background border-2 border-border dark:border-dark-border p-5 flex-1 overflow-y-auto">
          <h3 className="text-text-primary dark:text-dark-text-primary font-bold text-sm mb-3 flex items-center gap-2">
            {aiLogo ? (
              <img src={aiLogo} alt={aiName} className="w-5 h-5 object-contain" />
            ) : (
              <span>🤖</span>
            )}
            {aiName} Says:
          </h3>
          <p className="text-text-secondary dark:text-dark-text-secondary text-sm italic">
            {geminiCommentary ? `"${geminiCommentary}"` : 'Waiting for move...'}
          </p>
        </div>
      )}

      {/* Info */}
      <div className="mt-auto text-text-tertiary dark:text-dark-text-tertiary text-xs text-center space-y-1">
        <p className="font-medium">LMC Arena</p>
        <p>Powered by AI</p>
      </div>
    </div>
  );
};

export default SidePanel;
